import React from 'react'

import { getManager } from './manager'

export const download = ({ files, packageName, fetch }: any) => {
    const manager = getManager()

    const downloader = manager.getDownloader({
        processLimit: 5,
        packageName,
        fetch
    })

    // 单文件直接下载
    const isSingleFile = files.length === 1 && files[0].name === files[0].path

    if (isSingleFile) {
        downloader.processFile(files)
    } else {
        downloader.processZip(files)
    }
}

export default (Component, config) => {
    return ({ files, ...restProps }) => {
        const handleClick = async () => {
            let result

            if (typeof files === 'function') {
                result = await files()
            } else {
                result = files
            }

            download({ files: result })
        }

        return <Component onClick={handleClick} {...(config || {})} {...restProps} />
    }
}
